import React from 'react';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { FormattedMessage } from 'react-intl';

import { IconButton } from 'ui-components/components/button/icon-button';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { messages } from './messages';
import { useCreateShipment } from './use-create-shipment';
import { useFulfillmentPlanIdContext } from '../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';

export const CreateShipmentIconButton = () => {
  const salesOrderId = useSalesOrderIdContext();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const { createShipment, isCreateShipmentDisabled, isRestrictedByMarketplace, marketplaceName } = useCreateShipment(
    salesOrderId,
    fulfillmentPlanId,
  );

  const tooltipMessage = isRestrictedByMarketplace
    ? messages.restrictedByMarketplaceCreateShipmentIconButtonTooltip
    : messages.createShipmentIconButtonTooltip;

  return (
    <Tooltip>
      <span>
        <IconButton
          ariaLabelMessageDescriptor={messages.createShipmentIconButtonTooltip}
          disabled={isCreateShipmentDisabled}
          icon={faPlus}
          onClick={createShipment}
        />
      </span>
      <TooltipContent>
        <FormattedMessage {...tooltipMessage} values={{ marketplaceName }} />
      </TooltipContent>
    </Tooltip>
  );
};
